import styled from 'styled-components';

export const VideoViewerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
`;

export const VideoViewerContainer = styled.div`
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
  max-width: ${({ embedded }) => embedded ? '100%' : '1200px'};
  max-height: ${({ embedded }) => embedded ? 'none' : '90vh'};
  display: flex;
  flex-direction: column;
  position: ${({ embedded }) => embedded ? 'static' : 'relative'};
`;

export const VideoViewerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  background: #1a1a1a;
  border-bottom: 1px solid #333;
`;

export const VideoViewerBody = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  position: relative;
  max-height: ${({ embedded }) => embedded ? '450px' : 'none'};
  min-height: ${({ embedded }) => embedded ? '300px' : 'auto'};

  @media (max-width: 768px) {
    max-height: ${({ embedded }) => embedded ? '300px' : 'none'};
    min-height: ${({ embedded }) => embedded ? '200px' : 'auto'};
  }
`;

export const VideoViewerFooter = styled.div`
  background: #1a1a1a;
  border-top: 1px solid #333;
  padding: 16px 20px;
  opacity: ${props => props.show ? 1 : 0.7};
  transition: opacity 0.3s ease;
  
  &:hover {
    opacity: 1;
  }
`;

export const VideoPlayer = styled.video`
  width: 100%;
  height: 100%;
  max-height: ${({ embedded }) => embedded ? '450px' : '70vh'};
  min-height: ${({ embedded }) => embedded ? '300px' : 'auto'};
  object-fit: contain;
  cursor: pointer;

  @media (max-width: 768px) {
    max-height: ${({ embedded }) => embedded ? '300px' : '70vh'};
    min-height: ${({ embedded }) => embedded ? '200px' : 'auto'};
  }
`;

export const VideoControls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  color: white;
`;

export const ControlButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ProgressBar = styled.div`
  flex: 1;
  height: 6px;
  background: #333;
  border-radius: 3px;
  cursor: pointer;
  position: relative;
  margin: 0 16px;

  &:hover {
    height: 8px;
  }
`;

export const TimeDisplay = styled.div`
  color: white;
  font-size: 14px;
  font-weight: 500;
  min-width: 100px;
  text-align: center;
`;

export const VolumeControl = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  input[type="range"] {
    -webkit-appearance: none;
    appearance: none;
    height: 4px;
    background: #333;
    border-radius: 2px;
    outline: none;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 16px;
      height: 16px;
      background: #2c5f34;
      border-radius: 50%;
      cursor: pointer;
    }

    &::-moz-range-thumb {
      width: 16px;
      height: 16px;
      background: #2c5f34;
      border-radius: 50%;
      cursor: pointer;
      border: none;
    }
  }
`;

export const VideoInfo = styled.div`
  flex: 1;
  color: white;
`;

export const VideoTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: white;
`;

export const VideoDescription = styled.p`
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #ccc;
  line-height: 1.4;
`;

export const VideoMeta = styled.div`
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #999;

  span {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const DownloadButton = styled.button`
  background: #2c5f34;
  border: none;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;

  &:hover {
    background: #5B5BD6;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const CloseButton = styled.button`
  background: #EF4444;
  border: none;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;

  &:hover {
    background: #DC2626;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

// Responsive styles
export const ResponsiveVideoViewer = styled(VideoViewerContainer)`
  @media (max-width: 768px) {
    margin: 10px;
    max-height: 80vh;
    
    ${VideoViewerHeader} {
      padding: 16px;
    }
    
    ${VideoTitle} {
      font-size: 16px;
    }
    
    ${VideoDescription} {
      font-size: 13px;
    }
    
    ${VideoControls} {
      gap: 12px;
    }
    
    ${TimeDisplay} {
      font-size: 12px;
      min-width: 80px;
    }
  }
`;
